import http from '../http/http';
import URL from '../constant/URL';

const { LEARNING_HISTORY, NOTE } = URL.API.LEARNING;

// 주제학습 이력 조회
/**
 * @param {string} channel: 채널코드
 * @param {string} language: 언어코드
 * @param {string} learner: 학습자 아이디
 * @param {string} thmaCd: 대주제 코드
 * @param {string} currentPage: 현재페이지
 * @returns 
 */
export const learningHistoryListAPI = async (data) => {
  let result = null;
  const {
    channel,
    language,
    learner,
    thmaCd = "",
    entyPathCd = '',
    currentPage = 1
  } = data;

  const params = { thmaCd, currentPage, entyPathCd };
  await http.request({
    url: `${LEARNING_HISTORY}`
      + `/channel/${channel}`
      + `/language/${language}`
      + `/learners/${learner}`,
    method: http.METHOD.POST,
    data: params,
    success: (resp, code) => { 
      result = {resp, code};
    },
    error: (error) => { throw error }
  });

  return result;
}

// 진단결과
export const diagnosisResultAPI = async (data) => {
  let result = null;

  await http.request({
    url: `${NOTE.RESULT}`,
    method: http.METHOD.POST,
    data,
    success: (resp) => { result = resp; },
    error: (error) => { throw error }
  });

  return result;
}

// 학습노트 레벨 목록
export const levelListAPI = async (params) => {
  let result = null;
  const { channelCode, learnerId } = params;
  await http.request({
    url: `${URL.API.COURSE_LEARNING.NOTE}/level/channel/${channelCode}/language/KO/learners/${learnerId}`,
    success: (resp, code) => { 
      result = { resp, code }; 
    },
    error: (error) => { throw error }
  });

  return result;
}